import React from 'react';
import PropTypes from 'prop-types';
import { useRecoilValue } from 'recoil';
import { Box, Divider, Drawer, IconButton, Typography } from '@mui/material';
import closeIconBlack from 'assets/images/close-icon-black.svg';
import { toggleModal } from 'pages/reference-implementation/provisioning/RI003AWS/store';
import { InputInfo } from 'pages/reference-implementation/components/input-info';

const ConfigDrawer = ({ isOpen, title, titleInfo, subHeader, handleDrawerAction, children }) => {
    const modal = useRecoilValue(toggleModal);
    const isSubModalOpen = modal?.isPrivilegedADGroupOpen || modal?.isNonPrivilegedADGroupOpen || modal?.isADGroupModalOpen;

    React.useEffect(() => {
        const element = document.getElementById('rwc');
        if (element !== null) {
            if (isOpen) {
                document.getElementById('rwc').style.display = 'none';
            } else {
                document.getElementById('rwc').style.display = 'block';
            }
        }
    }, [isOpen?.toString()]);

    return (
        <Drawer
            data-testid="modal"
            PaperProps={{ sx: { width: '35%', ...(isSubModalOpen && { display: 'none' }) } }}
            ModalProps={{ keepMounted: true, BackdropProps: { sx: { ...(isSubModalOpen && { display: 'none' }) } } }}
            anchor="right"
            open={isOpen}
        >
            <Box
                sx={{
                    display: 'flex',
                    height: '100%',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    backgroundColor: (theme) => theme?.palette?.background?.$color_background_layer_01,
                }}
            >
                <Box
                    display="flex"
                    alignItems="center"
                    px={2}
                    justifyContent="space-between"
                    sx={{ color: (theme) => theme?.palette?.textColors?.$color_text_primary, minHeight: '28px', marginTop: '15px' }}
                >
                    <Box width="80%">
                        <Typography sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: '18px', fontWeight: '700' }} variant="subtitle1">
                            {title}
                            {titleInfo && <InputInfo maxWidth="400px" title={titleInfo} />}
                        </Typography>
                        {subHeader && <Typography variant="caption">{subHeader}</Typography>}
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }} width="20%">
                        <IconButton color="inherit" onClick={() => handleDrawerAction('cancel')} aria-label="close-modal" data-testid="close">
                            <img src={closeIconBlack} alt="" />
                        </IconButton>
                    </Box>
                </Box>
                <Divider />
                <Box overflow="auto" flexGrow={1} sx={{ p: 2 }}>
                    {children}
                </Box>
            </Box>
        </Drawer>
    );
};

ConfigDrawer.propTypes = {
    isOpen: PropTypes.bool,
    handleDrawerAction: PropTypes.func.isRequired,
    title: PropTypes.string,
    titleInfo: PropTypes.node,
    subHeader: PropTypes.string,
    children: PropTypes.any,
};

ConfigDrawer.defaultProps = {
    title: '',
    titleInfo: null,
    isOpen: true,
    children: <></>,
    subHeader: null,
};

export default React.memo(ConfigDrawer);
